var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M15.512 4.39L11.802.512C11.487.181 11.069 0 10.623 0H5.377c-.446 0-.864.181-1.179.51L.488 4.39C.173 4.72 0 5.159 0 5.624v5.487c0 .466.173.904.488 1.234l3.71 3.88c.315.329.733.51 1.179.51h5.246c.445 0 .864-.181 1.179-.51l3.71-3.88c.315-.33.488-.767.488-1.233V5.623c0-.465-.173-.903-.488-1.232z",
    transform: "translate(0 .067)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M10.623 16.734H5.377c-.445 0-.864-.181-1.179-.51l-3.71-3.88C.173 12.014 0 11.577 0 11.111V5.623c0-.465.173-.903.488-1.232L4.198.51C4.513.181 4.931 0 5.377 0h5.246c.445 0 .864.181 1.179.51l3.71 3.88c.315.33.488.768.488 1.233v5.487c0 .466-.173.904-.488 1.234l-3.71 3.88c-.315.329-.733.51-1.179.51zM5.377.697c-.264 0-.521.112-.708.306L.96 4.883c-.188.198-.292.46-.292.74v5.487c0 .28.104.543.292.74l3.71 3.88c.187.195.444.307.708.307h5.246c.264 0 .521-.112.708-.306l3.71-3.88c.188-.198.292-.46.292-.74V5.623c0-.28-.104-.542-.292-.74l-3.71-3.88c-.187-.194-.444-.306-.708-.306H5.377z",
    transform: "translate(0 .067)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000",
    fillOpacity: 0.87,
    fontFamily: "ArialRoundedMTBold, Arial Rounded MT Bold",
    fontSize: 5,
    letterSpacing: -0.2,
    transform: "translate(0 .067)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1.5,
    y: 10.367
  }, "STO"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.254,
    y: 10.367
  }, "P")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopIcon);
export default __webpack_public_path__ + "static/media/stop_icon.ddb24e432c781afcf16ee63afbc694c4.svg";
export { ForwardRef as ReactComponent };